import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=075a5dac&"
import script from "./Currency.vue?vue&type=script&lang=js&"
export * from "./Currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075a5dac')) {
      api.createRecord('075a5dac', component.options)
    } else {
      api.reload('075a5dac', component.options)
    }
    module.hot.accept("./Currency.vue?vue&type=template&id=075a5dac&", function () {
      api.rerender('075a5dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Svg/Currency.vue"
export default component.exports